import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEye, faEyeSlash, faUser, faPhone, faEnvelope,
    faLock, faStore, faCalendarAlt, faCheckCircle,
    faPaperPlane, faArrowRight, faSync
} from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../url';
import './RegisterUsuario.css';

export default function RegisterUsuario({ onSwitchToLogin }) {
    const [nombre, setNombre] = useState('');
    const [telefono, setTelefono] = useState('');
    const [tipoServicio, setTipoServicio] = useState('tienda'); // 'tienda' o 'citas'
    const [email, setEmail] = useState('');
    const [contrasena, setContrasena] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [cargando, setCargando] = useState(false);

    // Estado tras registro exitoso
    const [registroExitoso, setRegistroExitoso] = useState(false);
    const [emailRegistrado, setEmailRegistrado] = useState('');
    const [servicioRegistrado, setServicioRegistrado] = useState('');

    const handleTelefonoChange = (e) => {
        let val = e.target.value.replace(/\D/g, '');
        // Si el usuario pega con código de país 51 (ej: 51987654321), normalizar
        if (val.length === 11 && val.startsWith('519')) {
            val = val.substring(2);
        }
        // Si escribe un número, obligar a que el primer dígito sea 9
        if (val.length > 0 && !val.startsWith('9')) {
            toast.warning('El número de celular debe empezar con 9.');
            return;
        }
        if (val.length <= 9) {
            setTelefono(val);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!nombre || !email || !contrasena) {
            toast.warning('Por favor completa todos los campos requeridos.');
            return;
        }

        if (!telefono) {
            toast.warning('Por favor ingresa tu número de celular.');
            return;
        }

        if (!telefono.startsWith('9')) {
            toast.warning('El número de celular debe empezar obligatoriamente con el dígito 9.');
            return;
        }

        if (telefono.length !== 9) {
            toast.warning(`El número de celular debe tener exactamente 9 dígitos (ingresaste ${telefono.length}).`);
            return;
        }

        if (contrasena.length < 6) {
            toast.warning('La contraseña debe tener al menos 6 caracteres.');
            return;
        }

        setCargando(true);
        try {
            const formData = new FormData();
            formData.append('nombre', nombre.trim());
            formData.append('telefono', telefono.trim());
            formData.append('celular', telefono.trim());
            formData.append('tipo_servicio', tipoServicio);
            formData.append('servicio', tipoServicio);
            formData.append('rol', tipoServicio === 'citas' ? 'multi_cita' : 'usuario_tienda');
            formData.append('estado', 'activo');
            formData.append('email', email.trim());
            formData.append('contrasena', contrasena);

            const response = await fetch(`${baseURL}/registroPost.php`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });

            const data = await response.json();

            if (data.status === 'success' || (!data.error && data.mensaje)) {
                // Guardar correo para auto-llenarlo al pasar al login
                sessionStorage.setItem('last_registered_email', email.trim());
                setEmailRegistrado(email.trim());
                setServicioRegistrado(tipoServicio === 'citas' ? 'Reserva de Citas (Multi Cita)' : 'Gestión de Tienda');
                setRegistroExitoso(true);
                toast.success('¡Cuenta activada exitosamente con 1 mes de prueba!');
            } else {
                toast.error(data.error || 'Ocurrió un error al registrar la cuenta.');
            }
        } catch (error) {
            console.error('Error al registrar usuario:', error);
            toast.error(error.message || 'Error de conexión con el servidor.');
        } finally {
            setCargando(false);
        }
    };

    const resetForm = () => {
        setRegistroExitoso(false);
        setNombre('');
        setTelefono('');
        setEmail('');
        setContrasena('');
        setTipoServicio('tienda');
    };

    if (registroExitoso) {
        return (
            <div className='reg-success-wrapper'>
                <div className='reg-success-icon-box activated-box'>
                    <FontAwesomeIcon icon={faCheckCircle} className='icon-plane active-check' />
                </div>

                <div className='reg-active-badge'>
                    <span className='active-dot'></span> Cuenta 100% Activa
                </div>

                <h3 className='reg-success-title'>¡Cuenta Creada y Activada con Éxito!</h3>
                <p className='reg-success-desc'>
                    Tu cuenta ha sido activada de forma directa. No necesitas validar ningún enlace de correo electrónico.
                </p>
                <div className='reg-success-email-card'>
                    <FontAwesomeIcon icon={faEnvelope} />
                    <span>{emailRegistrado}</span>
                </div>

                <div className='reg-success-info-box'>
                    <p style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                        <FontAwesomeIcon icon={tipoServicio === 'citas' ? faCalendarAlt : faStore} style={{ color: '#4f46e5' }} />
                        <strong>Tipo de Cuenta:</strong> {servicioRegistrado}
                    </p>
                    <p style={{ margin: 0, fontSize: '0.84rem', color: '#059669', fontWeight: '700' }}>
                        🎁 Beneficio: 1 mes de prueba gratuito activado desde hoy
                    </p>
                    <p style={{ marginTop: '6px', fontSize: '0.82rem', color: '#64748b' }}>
                        Ya puedes iniciar sesión directamente con tu correo y contraseña para acceder al panel.
                    </p>
                </div>

                <div className='reg-success-actions'>
                    <button
                        type='button'
                        className='btn-switch-login'
                        onClick={() => {
                            if (onSwitchToLogin) onSwitchToLogin();
                            else window.location.reload();
                        }}
                    >
                        Iniciar Sesión Ahora <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                    <button
                        type='button'
                        className='btn-resend-back'
                        onClick={resetForm}
                    >
                        <FontAwesomeIcon icon={faSync} /> Registrar otra cuenta
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className='register-usuario-container'>
            <ToastContainer />

            <form onSubmit={handleSubmit} className='reg-modern-form'>

                {/* 1. Selector de Servicio: Tienda vs Reserva de Citas */}
                <div className='reg-service-selector-group'>
                    <label className='reg-group-label'>
                        ¿Qué tipo de cuenta deseas crear? <span className='req-star'>*</span>
                    </label>
                    <div className='reg-service-cards-grid'>
                        <div
                            className={`reg-service-card ${tipoServicio === 'tienda' ? 'active' : ''}`}
                            onClick={() => setTipoServicio('tienda')}
                        >
                            <div className='reg-service-icon-wrap icon-tienda'>
                                <FontAwesomeIcon icon={faStore} />
                            </div>
                            <div className='reg-service-info'>
                                <h4>Tienda</h4>
                                <p>Gestiona catálogo.</p>
                            </div>
                            <div className='reg-service-radio-pill'>
                                <div className='radio-dot'></div>
                            </div>
                        </div>

                        <div
                            className={`reg-service-card ${tipoServicio === 'citas' ? 'active' : ''}`}
                            onClick={() => setTipoServicio('citas')}
                        >
                            <div className='reg-service-icon-wrap icon-citas'>
                                <FontAwesomeIcon icon={faCalendarAlt} />
                            </div>
                            <div className='reg-service-info'>
                                <h4>Reserva de Citas</h4>
                                <p>Agenda Citas.</p>
                            </div>
                            <div className='reg-service-radio-pill'>
                                <div className='radio-dot'></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 2. Campo: Nombres */}
                <fieldset className='reg-fieldset'>
                    <legend>Nombres y Apellidos *</legend>
                    <div className='reg-input-icon-wrap'>
                        <FontAwesomeIcon icon={faUser} className='input-icon' />
                        <input
                            type="text"
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                            required
                            placeholder="Ej: Juan Pérez"
                        />
                    </div>
                </fieldset>

                {/* 3. Campo: Celular */}
                <fieldset className='reg-fieldset'>
                    <legend>Celular / Teléfono (9 dígitos) *</legend>
                    <div className='reg-input-icon-wrap'>
                        <FontAwesomeIcon icon={faPhone} className='input-icon' />
                        <input
                            type="tel"
                            inputMode="numeric"
                            value={telefono}
                            onChange={handleTelefonoChange}
                            maxLength={9}
                            required
                            placeholder="Ej: 987654321"
                        />
                    </div>
                </fieldset>

                {/* 4. Campo: Correo Electrónico */}
                <fieldset className='reg-fieldset'>
                    <legend>Correo Electrónico *</legend>
                    <div className='reg-input-icon-wrap'>
                        <FontAwesomeIcon icon={faEnvelope} className='input-icon' />
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="correo@ejemplo.com"
                        />
                    </div>
                </fieldset>

                {/* 5. Campo: Contraseña */}
                <fieldset className='reg-fieldset'>
                    <legend>Contraseña (mínimo 6 caracteres) *</legend>
                    <div className='reg-input-icon-wrap' style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '8px' }}>
                        <FontAwesomeIcon icon={faLock} className='input-icon' style={{ flexShrink: 0, color: '#94a3b8' }} />
                        <input
                            type={showPassword ? 'text' : 'password'}
                            value={contrasena}
                            onChange={(e) => setContrasena(e.target.value)}
                            required
                            placeholder="••••••••"
                            style={{ flex: 1, minWidth: 0, border: 'none', outline: 'none', background: 'transparent', width: 'auto' }}
                        />
                        <button
                            type="button"
                            className='btn-toggle-pass'
                            onClick={() => setShowPassword(!showPassword)}
                            title={showPassword ? 'Ocultar' : 'Mostrar'}
                            style={{ background: 'transparent', border: 'none', cursor: 'pointer', flexShrink: 0, padding: '0 4px', color: '#94a3b8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                        </button>
                    </div>
                </fieldset>

                {/* Botón de Envío */}
                <button
                    type="submit"
                    className='reg-submit-btn'
                    disabled={cargando}
                >
                    {cargando ? (
                        <span>Activando tu cuenta...</span>
                    ) : (
                        <>
                            <span>Registrarse y Activar Cuenta</span>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </>
                    )}
                </button>

                <p className='reg-terms-text'>
                    Al registrarte, tu cuenta se activará de forma inmediata con 1 mes de prueba gratuito sin necesidad de validar el correo electrónico.
                </p>
            </form>
        </div>
    );
}
